module.exports = __webpack_public_path__ + "static/media/risk-account-bg.26bb23b5.svg";